export const devLog = (...logs: any[]) => {
    if (import.meta.env.VITE_APP_ENVIRONMENT !== 'production') {
        console.log(...logs);
    }
};
